import React, { Component } from 'react'
import closeIcons from '../assets/icons/close.svg'
import Modal from 'react-modal'

export default class PhotoGrid extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentImage: null,
        }
    }

    render() {
        return (
            <React.Fragment>
                <Modal isOpen={this.state.currentImage} style={customStyles}>
                    <div className="col-12 h-100 px-0 text-center background-dark">
                        <img className="img-gallery" src={this.state.currentImage} />
                        <a onClick={this._onClickCloseImage.bind(this)} className="gallery-modal-close">
                            <img src={closeIcons} />
                        </a>
                    </div>
                </Modal>
                <div className="row">
                    {this.props.photosData.images.map((item, i) => {
                        let rowClass = 'col-lg-3'
                        if (i === 0 || i % 9 === 0) {
                            rowClass = 'col-lg-9'
                        } else if (i === 4 || i % 13 === 0) {
                            rowClass = 'col-lg-6'
                        }
                        return (
                            <div key={'image-' + i} className={' pb-4 ' + rowClass}>
                                <a
                                    onClick={() => {
                                        this._onClickOpenImage(item)
                                    }}
                                    href="#"
                                >
                                    <img className="img-metro-grid" src={item} />
                                </a>
                            </div>
                        )
                    })}
                </div>
            </React.Fragment>
        )
    }
    _onClickOpenImage(item) {
        this.setState({
            currentImage: item,
        })
    }
    _onClickCloseImage() {
        this.setState({
            currentImage: null,
        })
    }
}

const customStyles = {
    content: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        padding: 0,
    },
    overlay: {
        zIndex: 50,
    },
}

Modal.setAppElement('#root')
